
// keyboards keys

let keys = [
    {
        letter: 'Q',
        sound: 'Heater-1'
    },

    {
        letter: 'W',
        sound: 'Heater-2'
    },

    {
        letter: 'E',
        sound: 'Heater-3'
    },

    {
        letter: 'A',
        sound: 'Heater-4_1'
    },

    {
        letter: 'S',
        sound: 'Heater-6'
    },

    {
        letter: 'D',
        sound: 'Dsc_Oh'
    },

    {
        letter: 'Z',
        sound: 'Kick_n_Hat'
    },

    {
        letter: 'X',
        sound: 'RP4_KICK_1'
    },

    {
        letter: 'C',
        sound: 'Cev_H2'
    },
]


let keys2 = [
    {
        letter: 'Q',
        name: 'Chord-1',
        sound: 'Chord_1'
    },

    {
        letter: 'W',
        name: 'Chord-2',
        sound: 'Chord_2'
    },

    {
        letter: 'E',
        name: 'Chord-3',
        sound: 'Chord_3'
    },

    {
        letter: 'A',
        name: 'Shaker',
        sound: 'Give_us_a_light'
    },

    {
        letter: 'S',
        sound: 'Dry_Ohh',
        name: 'Open_HH',

    },

    {
        letter: 'D',
        name: 'Closed-HH',
        sound: 'Bld_H1'
    },

    {
        letter: 'Z',
        name: 'Punchy-Kick',
        sound: 'punchy_kick_1'
    },

    {
        letter: 'X',
        name: 'Side-Stick',
        sound: 'side_stick_1'
    },

    {
        letter: 'C',
        name: 'Snare',
        sound: 'Brk_Snr'
    },
]


export { keys, keys2 };